export enum BOOK_TYPE {
  LIBRARY = 'LIBRARY',
  LIBRARY3 = 'LIBRARY3',
  BIBLIOTECA = 'BIBLIOTECA',
  CAMINOS_BIBLIOTECA = 'CAMINOS',
  CAMINOS_3_BIBLIOTECA = 'CAMINOS_3',
  CAMINOS_3_CA_BIBLIOTECA = 'CAMINOS_3_CA',
  TEXAS_ELAR = 'TEXAS_ELAR',
  TEXAS_SLAR = 'TEXAS_SLAR',
  TEXAS_ELAR_2E = 'TEXAS_ELAR_2E',
  TEXAS_SLAR_2E = 'TEXAS_SLAR_2E',
}

export enum ebookKeys {
  LIBRARY = 'library',
  LIBRARY3 = 'library',
  BIBLIOTECA = 'biblioteca',
  CAMINOS = 'caminos',
  CAMINOS_3 = 'caminos',
  CAMINOS_3_CA = 'caminos3ca',
  TEXAS_ELAR = 'texaselar',
  TEXAS_SLAR = 'texasslar',
  TEXAS_ELAR_2E = 'texaselar2E',
  TEXAS_SLAR_2E = 'texasslar2E',
}

export const EBOOK_META_CHAPTERS = [
  'cover',
  'front cover',
  'table of contents',
  'tables of contents',
  'title page',
  'tapa',
  'title',
  'portada',
  'contenido',
  'contents',
]

export const EBOOK_TOC_PART_REG = /^(parte|part)\s\w{1,5}\s?$/i

export const EBOOK_TOC_CHAPTERS = {
  INTRO: ['introduction', 'introducción', 'introducción'],
  CHAPTER: ['chapter', 'capítulo', 'capítulo'],
}

export const READERS_TABS = {
  SKILLS_2021: 'Updated Skills Readers',
  SKILLS_2020: 'Skills Readers',
}

export const ZOOM_STEP_AMOUNT = 0.25
export const MAX_ZOOM_LEVEL = 2
export const MIN_ZOOM_LEVEL = 1
export const ZOOM_TRANSLATE_LEFT_PER_STEP = 330
export const ZOOM_TRANSLATE_TOP_PER_STEP = 320

/**
 * Maps userDistrictId to a list of book titles that should be hidden for that district
 */
export const DISTRICT_HIDDEN_BOOK_RULES: Record<string, string[]> = {
  // 'a2693a61-2be9-4367-83f8-4a7b479b4ac7' is a test district for devci environment
  'a2693a61-2be9-4367-83f8-4a7b479b4ac7': [
    'Unit 7: William Shakespeare’s A Midsummer Night’s Dream',
    'Unidad 7: Sueño de una noche de verano de William Shakespeare',
    'Unidad 7: Sueño de una noche de verano',
  ],
  // Idaho Falls School District #91
  '075aa39d-48a4-4712-bce9-41855394c9c3': [
    'Unit 7: William Shakespeare’s A Midsummer Night’s Dream',
    'Unidad 7: Sueño de una noche de verano de William Shakespeare',
    'Unidad 7: Sueño de una noche de verano',
  ],
}
